import React from "react";
import "./style.css";
import {BaseInput} from "../../designSystem/components/BaseInput";
import {Box} from "@mui/material";

export const ShortAnswer = ({
  label = '', value, onChange, className='', disabled=false, type='text', placeholder=''
}) => {
  return (
    <Box className={`short-answer ${className}`}>
      {label ? <Box className="page-title text-xl">
        {label}
      </Box> : null}
      <BaseInput onChange={onChange} isDisabled={disabled} value={value} type={type} placeholder={placeholder} />
    </Box>
  )
}
